import React from 'react';
import { useSelector } from 'react-redux';
import i18n from 'i18next';

import DialogSystem from 'client/components/DialogSystem';

export default function DialogBindCyberbizECMember({ open, onClose = () => {} }) {
    const { officialSiteUrl } = useSelector(s => s.sponsor);
    const hasOfficialSiteUrl = Boolean(officialSiteUrl);

    return (
        <DialogSystem
            isOpen={open}
            title={i18n.t('label.no_qualify_join')}
            body={i18n.t(
                hasOfficialSiteUrl
                    ? 'desc.sorry_no_qualify.cyberbiz_ec_member'
                    : 'desc.sorry_no_qualify.cyberbiz_ec_member.no_bind_url'
            )}
            endButton={i18n.t(hasOfficialSiteUrl ? 'btn.bind_account' : 'btn.understood')}
            closePopup={() => {
                if (hasOfficialSiteUrl) {
                    window.open(officialSiteUrl);
                }
                onClose();
            }}
        />
    );
}
